<template>
  <div class="prompt_wrapper" v-show="isShow">
    <div class="prompt">
      <div class="prompt_title">{{ title }}</div>
      <div class="prompt_input_wrapper">
        <slot name="content"></slot>
      </div>
      <div class="prompt_btn_wrapper flex-algin border-top">
        <div class="prompt_btn flex_item" v-if="showCancelBtn" @click.prevent="cancelCallback">{{ cancelText }}</div>
        <div class="prompt_btn flex_item border_left" @click.prevent="okCallback">{{ okText }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted,computed } from 'vue';
export default {
  name: 'popups',
  props: {
    title: {
      type: String,
      default: computed(() => $t('title'))
    },
    okText: {
      type: String,
      default: computed(() => $t('confirm'))
    },
    cancelText: {
      type: String,
      default: computed(() => $t('cancel'))
    },
    okColor: {
      type: String,
      default: '#000000'
    },
    cancelColor: {
      type: String,
      default: '#000000'
    },
    showCancelBtn: {
      type: Boolean,
      default:true
    }
  },
  setup(props, context) {
    const state = reactive({
      isShow: false
    });
    const cancelCallback = () => {  //取消
      state.isShow = false;
      context.emit("cancel");
    }

    const okCallback = () => {  //确定
      // state.isShow = false;
      context.emit("confirm", 666);
    }
    onMounted(() => {

    });
    return {
      ...toRefs(state), cancelCallback, okCallback, ...props
    };
  }
}
</script>

<style scoped lang="less">
.prompt_wrapper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .6);
}

.prompt {
  position: absolute;
  top: 45%;
  left: 10%;
  width: 80%;
  transform: translateY(-50%);
  border-radius: 5px;
  background-color: #fff;
  overflow: hidden;
}

.prompt_title {
  padding: 20px 10px 0;
  text-align: center;
  line-height: 22px;
  font-size: 15px;
}

.prompt_input_wrapper {
  padding: 25px 15px;
  font-size: 15px;
}

.prompt_input {
  display: block;
  box-sizing: border-box;
  width: 100%;
  padding: 12px;
  line-height: 20px;
  height: 44px;
  border: 1px solid #ccc;
  border-radius: 3px;
}

.prompt_btn {
  padding: 15px 10px;
  text-align: center;
  font-size: 15px;
}

.prompt_btn:active {
  background-color: #f7f7f7 !important;
}

.border_left {
  border-left: 1px solid #c8c7cc;
}
</style>
